module.exports = __webpack_public_path__ + "img/34.da735262.jpg";